// extracted by mini-css-extract-plugin
module.exports = {"textarea-itself":"src-components-Textarea-styles__textarea-itself--137Qs"};